import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';

const extendedManufConfigurationSchema = z
  .object({
    enabled: z.boolean().nullable(),
    warehouseId: z.string().nullish(),
    displayName: z.string().nullish(),
  })
  .nullish()
  .refine(
    (value) =>
      !value?.enabled ||
      Boolean(value.warehouseId && value.warehouseId.trim().length > 0),
    {
      message: REQUIRED_MESSAGE,
      path: ['warehouseId'],
    },
  )
  .refine(
    (value) =>
      !value?.enabled ||
      Boolean(value.displayName && value.displayName.trim().length > 0),
    {
      message: REQUIRED_MESSAGE,
      path: ['displayName'],
    },
  );

export const supplierTemplateFormSchema = z.object({
  name: requiredString,
  criteria: z
    .array(
      z.object({
        criterion: z.object({ id: z.string() }),
        values: z.array(requiredString).min(1, {
          error: REQUIRED_MESSAGE,
        }),
      }),
    )
    .min(1, {
      error: REQUIRED_MESSAGE,
    }),
  suppliers: z
    .array(
      z.object({
        code: z.string().nullable(),
        wyzApiId: z.number(),
        name: z.string(),
        type: z.number(),
        orderable: z.boolean().nullable(),
        overridePriorityIfShorterDelivery: z.boolean().nullable(),
        customName: z.string().nullish(),
        status: z.string(), // api use only
        enabled: z.boolean(), // form use only
        rankingModelId: z.string().nullish(),
        childCustomerDelivery: z.boolean(),
        bestSourcingConfigurations: z
          .array(
            z.object({
              brands: z
                .array(
                  z.object({
                    label: z.string(),
                    value: z.string(),
                  }),
                )
                .min(1, { error: REQUIRED_MESSAGE }),
              suppliers: z
                .array(
                  z.object({
                    label: z.string(),
                    value: z.number(),
                    rank: z.number(),
                  }),
                )
                .min(1, { error: REQUIRED_MESSAGE }),
            }),
          )
          .nullish(),
        bestPriceDelay: z.boolean().nullish(),
        extendedManufConfiguration: extendedManufConfigurationSchema,
      }),
    )
    .min(1, {
      error: REQUIRED_MESSAGE,
    }),
  bestSourcingSupplierConfigurations: z
    .record(
      z.string(),
      z.object({
        status: z.string().nullish(),
        enabled: z.boolean().nullish(),
        orderable: z.boolean().nullish(),
        childCustomerDelivery: z.boolean().nullish(),
        rankingModelId: z.string().nullish(),
        customName: z.string().nullish(),
        extendedManufConfiguration: extendedManufConfigurationSchema,
      }),
    )
    .nullish(),
});
